import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dw-record-marker__container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.5 5L1.5 1H9.5L5.5 5Z",
  fill: "currentColor",
  stroke: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_action_sequence_icon = _resolveComponent("dw-action-sequence-icon")!
  const _component_dw_marker_state = _resolveComponent("dw-marker-state")!

  return (_openBlock(), _createElementBlock("div", {
    class: "dw-record-marker",
    style: _normalizeStyle({ borderColor: _ctx.computedColor })
  }, [
    (_ctx.isCourierItem && _ctx.isEntityCompleted)
      ? (_openBlock(), _createBlock(_component_dw_action_sequence_icon, {
          key: 0,
          class: "dw-record-marker__sequence",
          "action-sequence": _ctx.entity.actionSequence
        }, null, 8, ["action-sequence"]))
      : (_ctx.isEntityCompleted)
        ? (_openBlock(), _createBlock(_component_dw_marker_state, {
            key: 1,
            class: "dw-record-marker__state",
            type: "green"
          }))
        : _createCommentVNode("", true),
    (_ctx.entity.waitListStatus !== null)
      ? (_openBlock(), _createBlock(_component_dw_marker_state, {
          key: 2,
          class: "dw-record-marker__state",
          type: "purple"
        }))
      : _createCommentVNode("", true),
    (_ctx.entity.delaying)
      ? (_openBlock(), _createBlock(_component_dw_marker_state, {
          key: 3,
          class: "dw-record-marker__state",
          type: "downtime"
        }))
      : _createCommentVNode("", true),
    (_ctx.entity.downtimes.length)
      ? (_openBlock(), _createBlock(_component_dw_marker_state, {
          key: 4,
          class: "dw-record-marker__state",
          type: "red"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "dw-record-marker__header",
      style: _normalizeStyle({ backgroundColor: _ctx.computedColor })
    }, [
      (_ctx.entity.type === 1)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString((_ctx.entity as DispatcherWorkplaceTake).orderNumber), 1)
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.entity.type === 2)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString((_ctx.entity as DispatcherWorkplaceDelivery).invoiceNumber), 1)
          ], 64))
        : _createCommentVNode("", true)
    ], 4),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.entity.timeSlot), 1),
    (_openBlock(), _createElementBlock("svg", {
      class: "dw-record-marker__anchor",
      style: _normalizeStyle({ color: _ctx.computedColor }),
      width: "11",
      height: "6",
      viewBox: "0 0 11 6",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, _hoisted_3, 4))
  ], 4))
}